<template>
  <div class="quality-recommend">
    <div class="slider-banner swiper">
      <swiper class="swiper-wrapper" :options="RecommendSwiper">
        <swiperSlide
          class="swiper-slide"
          v-for="(item, index) in imgUrls"
          :key="index"
        >
          <img :src="item.img" class="slide-image" />
        </swiperSlide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div>
    <div class="title acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="name">
        <span class="iconfont" :class="icon"></span>{{ name }}
      </div>
      <div class="line"></div>
    </div>
    <GoodList :good-list="goodsList" :is-sort="false"></GoodList>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import { isWeixin } from "@utils/index";
import { getGroomList } from "@api/store";
import { mapGetters } from "vuex";
import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { getUser,getUserOpenId, getMenuUser } from "@api/user";
export default {
  name: "HotNewGoods",
  components: {
    swiper,
    swiperSlide,
    GoodList
  },
  computed: mapGetters(["isLogin"]),
  props: {},
  data: function() {
    return {
      imgUrls: [],
      goodsList: [],
      name: "",
      icon: "",
      RecommendSwiper: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    this.titleInfo();
    this.getIndexGroomList();
    this.setOpenShare();
  },
  methods: {
    titleInfo: function() {
      let type = this.$route.params.type;
      if (type === "1") {
        this.name = "精品推荐";
        this.icon = "icon-jingpintuijian";
        document.title = "精品推荐";
      } else if (type === "2") {
        this.name = "热门榜单";
        this.icon = "icon-remen";
        document.title = "热门榜单";
      } else if (type === "3") {
        this.name = "首发新品";
        this.icon = "icon-xinpin";
        document.title = "首发新品";
      }else if (type === "5") {
        this.name = "礼包专区";
        this.icon = "icon-xinpin";
        document.title = "礼包专区";
      }else if (type === "6") {
        this.name = "母婴提货区";
        this.icon = "icon-xinpin";
        document.title = "母婴提货区";
      }else if (type === "7") {
        this.name = "礼包专区";
        this.icon = "icon-xinpin";
        document.title = "礼包专区";
      }else if (type === "8") {
        this.name = "直购商城";
        this.icon = "icon-xinpin";
        document.title = "直购商城";
      }
    },
    getIndexGroomList: function() {
      let that = this;
      let type = this.$route.params.type;
      console.log(type);
      getGroomList(type)
        .then(res => {
          that.imgUrls = res.data.banner;
          that.goodsList = res.data.list;
          console.log(res.data.list);
        })
        .catch(function(res) {
          this.$dialog.toast({ mes: res.msg });
        });
    },
    setOpenShare() {
      if (isWeixin()) {
        if(this.isLogin){

          getUser().then(res => {
            var href = location.href;

            href =
                    href.indexOf("?") === -1
                            ? href + "?spread=" + res.data.uid
                            : href + "&spread=" + res.data.uid;
            var nickname = res.data.nickname;


            getShare().then(res => {
              var data = res.data.data;
              var configAppMessage = {
                desc: '['+nickname+'邀请] '+data.synopsis,
                title: data.title,
                link: href,
                imgUrl: data.img
              };
              openShareAll(configAppMessage);
            });
          })
        }else{
          getShare().then(res => {
            var data = res.data.data;
            var configAppMessage = {
              desc: data.synopsis,
              title: data.title,
              link: location.href,
              imgUrl: data.img
            };
            openShareAll(configAppMessage);
          });
        }


      }
    }
  }
};
</script>
